import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import {getBmwSerial, kwToHp} from '../utils/vehicles';
import { formatDate, formatDateTime } from '../utils/date';
import FavouritesPanel from "./FavouritesPanel";

function ResultPage({
  favourites,
  isLoading,
  onAddFavourite,
  onOpenVehicle,
  onRemoveFavourite,
  onReset,
  selectedVehicle,
}) {
  const bmwSerial =
    selectedVehicle && selectedVehicle.manufacturer === 'BMW' ? getBmwSerial(selectedVehicle.full_vin) : null;
  const isFavourite =
    selectedVehicle && favourites.some((vehicle) => vehicle.plate === selectedVehicle.plate);

  if (isLoading) {
    return (
      <main>
        <Container className="py-5 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Fetching vehicle details...</p>
        </Container>
      </main>
    );
  }

  if (!selectedVehicle) {
    return null;
  }

  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} xl={9}>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4">
              <div>
                <p className="text-body-secondary text-uppercase small mb-1">Licence plate</p>
                <div className="d-flex align-items-center gap-3">
                  <h1 className="h2 mb-0">{selectedVehicle.plate}</h1>
                </div>
              </div>
              <div className="d-flex flex-column flex-sm-row gap-2">
                {isFavourite ? (
                  <Button variant="outline-danger" type="button" onClick={() => onRemoveFavourite(selectedVehicle.plate)}>
                    Remove from favourites
                  </Button>
                ) : (
                  <Button variant="primary" type="button" onClick={onAddFavourite}>
                    Add to favourites
                  </Button>
                )}
                <Button variant="outline-secondary" type="button" onClick={onReset}>
                  Back to lookup
                </Button>
              </div>
            </div>

            <Row className="g-4">
              <Col xs={12} lg={7}>
                <Card className="shadow-sm">
                  <Card.Body className="p-4">
                    <h2 className="h4 mb-3">{`${selectedVehicle.manufacturer} ${selectedVehicle.model}`}</h2>
                    <Table responsive className="mb-0 align-middle">
                      <tbody>
                        <tr>
                          <th scope="row">Power</th>
                          <td>{`${selectedVehicle.powerKw} kW`} / {kwToHp(selectedVehicle.powerKw)}hp</td>
                        </tr>
                        <tr>
                          <th scope="row">Engine code</th>
                          <td>{selectedVehicle.engine_code}</td>
                        </tr>
                        <tr>
                          <th scope="row">Fuel</th>
                          <td>{selectedVehicle.fuel}</td>
                        </tr>
                        {selectedVehicle.displacement && (
                          <tr>
                            <th scope="row">Displacement</th>
                            <td>{`${selectedVehicle.displacement} cm³`}</td>
                          </tr>
                        )}
                        {selectedVehicle.first_registered && (
                          <tr>
                            <th scope="row">First registered</th>
                            <td>{formatDate(selectedVehicle.first_registered)}</td>
                          </tr>
                        )}
                        {selectedVehicle.data_source && (
                          <tr>
                            <th scope="row">Data source</th>
                            <td>
                              <Badge
                                bg={
                                  selectedVehicle.data_source.toLowerCase() === 'motonet'
                                    ? 'danger'
                                    : selectedVehicle.data_source.toLowerCase() === 'biltema'
                                    ? 'primary'
                                    : 'secondary'
                                }
                              >
                                {selectedVehicle.data_source}
                              </Badge>
                            </td>
                          </tr>
                        )}
                        {selectedVehicle.last_update && (
                            <tr>
                              <th scope="row">Last updated</th>
                              <td>{formatDateTime(selectedVehicle.last_update)}</td>
                            </tr>
                        )}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>

              <Col xs={12} lg={5}>
                <Card className="shadow-sm">
                  <Card.Body className="p-4">
                    <h2 className="h5 mb-3">VIN</h2>
                    <p className="mb-0">{selectedVehicle.full_vin}</p>
                    <hr />
                    <div className="d-flex flex-wrap gap-3">
                      <Card.Link
                        href={`https://www.biltema.fi/auton-varaosahaku/${selectedVehicle.plate}/`}
                        target="_blank"
                        rel="noreferrer"
                        className="ms-0"
                      >
                        Open Biltema
                      </Card.Link>
                      {bmwSerial && (
                        <Card.Link
                          href={`https://www.realoem.com/bmw/enUS/select?vin=${bmwSerial}`}
                          target="_blank"
                          rel="noreferrer"
                          className="ms-0"
                        >
                          Open BMW RealOEM
                        </Card.Link>
                      )}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <FavouritesPanel favourites={favourites} onOpenVehicle={onOpenVehicle} onRemoveFavourite={onRemoveFavourite} selectedVehicle={selectedVehicle}/>
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default ResultPage;
